import { useTranslation } from "react-i18next";
import { useMovimientos } from "@/hooks/useMovimientos";
import { LoadingScreen } from "@/components/layout/LoadingScreen";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export const MovimientosTab = () => {
  const { t } = useTranslation();
  const { movements, loading, totalIn, totalOut } = useMovimientos();

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <Card className="bg-green-500/5 border-green-500/20">
          <CardContent className="p-4">
            <p className="text-xs text-muted-foreground uppercase">{t("financiero.income")}</p>
            <p className="text-2xl font-bold text-green-400">{totalIn.toFixed(2)}€</p>
          </CardContent>
        </Card>
        <Card className="bg-red-500/5 border-red-500/20">
          <CardContent className="p-4">
            <p className="text-xs text-muted-foreground uppercase">{t("financiero.expenses")}</p>
            <p className="text-2xl font-bold text-red-400">{totalOut.toFixed(2)}€</p>
          </CardContent>
        </Card>
        <Card className="bg-blue-500/5 border-blue-500/20">
          <CardContent className="p-4">
            <p className="text-xs text-muted-foreground uppercase">{t("financiero.balance")}</p>
            <p className="text-2xl font-bold text-blue-400">{(totalIn - totalOut).toFixed(2)}€</p>
          </CardContent>
        </Card>
        <Card className="bg-yellow-500/5 border-yellow-500/20">
          <CardContent className="p-4">
            <p className="text-xs text-muted-foreground uppercase">{t("financiero.movements")}</p>
            <p className="text-2xl font-bold text-yellow-400">{movements.length}</p>
          </CardContent>
        </Card>
      </div>
      {loading ? <LoadingScreen /> : (
        <div className="grid gap-2">
          {movements.map(m => (
            <Card key={m.id} className="card-hover">
              <CardContent className="flex items-center justify-between p-4">
                <div className="flex items-center gap-4">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center ${m.type === "income" ? "bg-green-500/20" : "bg-red-500/20"}`}>
                    {m.type === "income"
                      ? <ArrowUpRight className="w-4 h-4 text-green-400" />
                      : <ArrowDownRight className="w-4 h-4 text-red-400" />}
                  </div>
                  <div>
                    <p className="font-medium text-sm">{m.description}</p>
                    <p className="text-xs text-muted-foreground">{m.date}</p>
                  </div>
                </div>
                <span className={`font-bold ${m.type === "income" ? "text-green-400" : "text-red-400"}`}>
                  {m.type === "income" ? "+" : "-"}{m.amount.toFixed(2)}€
                </span>
              </CardContent>
            </Card>
          ))}
          {movements.length === 0 && <p className="text-center text-muted-foreground py-8">{t("financiero.noMovements")}</p>}
        </div>
      )}
    </div>
  );
};
